import { AppConfiguration, FaxUser } from '../types';

export const passwordLengthMin = 8;
export const config: AppConfiguration = {
  appVersion: '0.0.0',
  companyName: '',
  siteName: 'FAX',
  productName: 'WebFAX',
  productIcon: '',
  loginUrl: 'login',
  siteAuthentication: 'token',
  passwordResetEnabled: false,
  passwordChangeEnabled: false,
  faxSendUrl: 'faxSend',
  headerColor: '#1976D2',
  headerTextColor: '#000000',
  phoneNumberLengthMin: 7,
  phoneNumberLengthMax: 15,
  invalidNumberDisplayMax: 10,
  contactSummaryDisplayMax: 5,
  firstNameLengthMax: 25,
  lastNameLengthMax: 25,
  companyLengthMax: 50,
  contactsCsvHeaderNames: ['FAXNUMBER', 'FIRSTNAME', 'LASTNAME', 'COMPANY', 'GROUPS'],
  recipientsCsvHeaderNames: ['FAXNUMBER', 'FIRSTNAME', 'LASTNAME', 'COMPANY'],
  faxNumberRules: [
    (v: string) => !!v || 'Fax number is required.',
    (v: string) =>
      v.length >= config.phoneNumberLengthMin ||
      `Fax number must be at least ${config.phoneNumberLengthMin} digits.`,
    (v: string) =>
      v.length <= config.phoneNumberLengthMax ||
      `Fax number must be at most ${config.phoneNumberLengthMax} digits.`,
    // TODO: check for duplicate fax numbers (recipients/contacts)
  ],
  firstNameRules: [
    (v: string) =>
      v.length <= config.firstNameLengthMax ||
      `First name must be at most ${config.firstNameLengthMax} characters.`,
  ],
  lastNameRules: [
    (v: string) =>
      v.length <= config.lastNameLengthMax ||
      `Last name must be at most ${config.lastNameLengthMax} characters.`,
  ],
  companyRules: [
    (v: string) =>
      v.length <= config.companyLengthMax ||
      `Company must be at most ${config.companyLengthMax} characters.`,
  ],
  emailRules: [(v) => !v || /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})$/.test(v) || 'E-mail must be valid'],
  cdrTimeZone: 'UTC-8',
  maxLogoFileSizeKB: 2 * 1024,
  cdrStatus: (code: string): string => {
    if (parseInt(code) < 0) {
      return 'Failed';
    }

    switch (code) {
      case '0':
        return 'Pending';
      case '1':
        return 'In Progress';
      case '2':
        return 'Sent';
      default:
        return 'Unknown';
    }
  },
  coverPages: [
    {
      text: 'None',
      value: '',
    },
    {
      text: 'Cover Page 1',
      value: 'fax-cover-1',
    },
    {
      text: 'Cover Page 2',
      value: 'fax-cover-2',
    },
    {
      text: 'Cover Page 3',
      value: 'fax-cover-3',
    },
  ],
  addresBookDisabledMessage:
    'This feature is disabled for your account. Please contact support or upgrade your account to use this feature.',
};

export const defaultUser: FaxUser = {
  Username: '',
  ANI: '',
  NotificationEmail: null,
  Retries: 0,
  SubmittedFaxTimeout: 180,
  MaxGroups: 9,
  MaxNumGroups: 99,
  MaxNumRecipientsPerGroup: 99,
  MaxNumRecipients: 1,
  MaxNumContacts: 9999,
  AllowRecipientUpload: false,
  AllowAddressBook: false,
  MaxNumAttachments: 1,
  MaxPagesPerAttachment: 100,
  MaxAttachmentSizeKB: 5120,
  MaxTotalAttachmentSizeKB: 5120,
  CoverPageList: '',
  TimeZone: 'America/Los_Angeles',

  coverPages: [
    {
      text: 'None',
      value: '',
    },
    {
      text: 'Cover Page 1',
      value: 'fax-cover-1',
    },
    {
      text: 'Cover Page 2',
      value: 'fax-cover-2',
    },
    {
      text: 'Cover Page 3',
      value: 'fax-cover-3',
    },
  ],
};
